import { WarningOutlined } from '@ant-design/icons'
import { Button, Flex, Result } from 'antd'
import { useTranslation } from 'react-i18next'

interface ErrorResultProps {
  message: string
  /**
   * Sahifaga xos sarlavha. Berilmasa — umumiy «Nimadir xato ketdi».
   * Aniq sarlavha mehmonga NIMA yiqilganini aytadi: "Nimadir xato ketdi"
   * ostidagi sabab qaysi qadamga tegishli ekani ko'rinmasdi.
   */
  title?: string
  /** Bo'lsa — "Qayta urinish" tugmasi ko'rsatiladi (vazifa talabi: bo'sh ekran qoldirmaslik) */
  onRetry?: () => void
  retryLoading?: boolean
  retryDisabled?: boolean
  /** Bo'lsa — butun oqimni boshidan boshlash tugmasi */
  onStartOver?: () => void
}

/**
 * Umumiy xato ekrani — HAR bir bosqichda ishlatiladi (Entry, SMS, Vaucher,
 * Reklama). Vazifa talabi: "aniq, ayblovsiz matn + nima qilish kerakligi".
 * Shuning uchun bu yerda hech qachon xom texnik xabar (stack trace, HTTP
 * kodi) ko'rsatilmaydi — faqat `translatePortalError` dan kelgan, oldindan
 * tarjima qilingan matn.
 */
export function ErrorResult({
  message,
  title,
  onRetry,
  retryLoading,
  retryDisabled,
  onStartOver,
}: ErrorResultProps) {
  const { t } = useTranslation()

  return (
    <Result
      icon={<WarningOutlined />}
      status="warning"
      title={title ?? t('error.title')}
      subTitle={message}
      extra={
        <Flex vertical gap={8}>
          {onRetry ? (
            <Button
              type="primary"
              block
              size="large"
              onClick={onRetry}
              loading={retryLoading}
              disabled={retryDisabled}
            >
              {t('common.retry')}
            </Button>
          ) : null}
          {onStartOver ? (
            <Button block size="large" onClick={onStartOver}>
              {t('common.startOver')}
            </Button>
          ) : null}
        </Flex>
      }
    />
  )
}
